import { useMemo } from 'react';
import { Channel } from 'stream-chat';
import useUser from '@hooks/user/use-user';
import { Product } from '@interfaces/models/product';
import { getBuyerInfoFromChannel } from '@helpers/chat-helpers';

export const useReceiverInfo = (product: Product, channel: Channel) => {
  const { user } = useUser();
  const isSeller = product?.seller?.id === user?.id;
  return useMemo(() => (isSeller ? getBuyerInfoFromChannel(channel) : product?.seller), [isSeller, channel, product]);
};
